import { useState, useEffect, useMemo } from 'react';
import CONTACTS from 'consts/contacts.consts';
import NeoCard from 'design/design_components/neo/panel/NeoCard.base';
import NeoInputText from 'design/design_components/neo/form/NeoInputText.base';
import NeoInnerTitle from 'design/design_components/neo/title/NeoInnerTitle.base';
import useComponent from 'hooks/useComponent.hook';

const ContactExtraTextFieldsForm = (props) => {
  const component = useComponent({state: {changed: {}}});
  const [texts, setTexts] = useState(Array(CONTACTS.DATA.EXTRA_TEXT_FIELDS).fill('').map((_, index) => {
    const field = `text${index + 1}`;
    return props.contact ? (props.contact[field] ?? '') : '';
  }));

  useEffect(() => component.setState((state) => {state.changed = {}}), [props.contact]);
  useEffect(() => handleChange(), [props.contact]);
  useEffect(() => handleChange(), [texts]);

  const render = useMemo(() => {
    if(props.showOnlyFills) {
      return texts.reduce((render, value, index) => {
        return render === true ? true : (value.length > 0 || component.state.changed[`text${index + 1}`])
      }, false);
    }
    return true;
  }, [props.showOnlyFills, texts, component.state.changed]);

  const handleChange = () => {
    const event = { payload: {} };
    const changes = texts.map((text, index) => {
      const field = `text${index + 1}`;
      event.payload[field] = text;
      return props.contact && text !== props.contact[field];
    });
    if (props.contact) {
      event.change = changes.some((change) => change === true);
    }
    props.onChange(event);
  }

  const handleTextInputChange = (index, event) => {
    const value = event.value ?? event.target.value;
    const updatedTexts = [...texts];
    updatedTexts[index] = value;
    setTexts(updatedTexts);
  }

  return (<>
  {render &&
    <NeoCard>
      <NeoInnerTitle extra='primero'>Campos de texto</NeoInnerTitle>
      {
        texts.map((text, index) => (
          (!props.showOnlyFills || text.length > 0 || component.state.changed[`text${index + 1}`]) &&
            <NeoInputText
              key={index}
              md={props?.elements?.text?.md}
              col="12"
              label={`Texto ${index + 1}`}
              value={text}
              onChange={(event) => handleTextInputChange(index, event)}
              onFocus={() => {component.setState((state) => {state.changed[`text${index + 1}`] = true})}}
            />
        ))
      }
    </NeoCard>
  }</>);
}

ContactExtraTextFieldsForm.defaultProps = {
  elements: {
    text: {
      md: '4'
    }
  },
  showOnlyFills: false
}

export default ContactExtraTextFieldsForm;